
import {createSlice} from '@reduxjs/toolkit'
import { fetchcustomerType } from '../../action/master/customerTypeAction'

interface customerTypeState {
  data: any
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: customerTypeState = {
  data: null,
  status: 'idle',
  error: null,
}

const customerTypeSlice = createSlice({
  name: 'customerType',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchcustomerType.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchcustomerType.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        
      })
      .addCase(fetchcustomerType.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message || 'Failed to fetch business type data'
      })
  },
})

export default customerTypeSlice.reducer
